import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
// Redux
import { useDispatch, useSelector } from 'react-redux';
import {
	Button,
} from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';


// Component
import CountDown from '../../CountDown';
import Link from '../../Link';
// Locale
import messages from '../../../locale/jsonMessages';

// Redux action
import { sendMessageAction } from '../../../actions/message/sendMessageAction';
import { ClockSvgIcon } from '../../Common/Assets/SvgIconComponent/CommonSvgIcon';

import cs from '../../commonStyle.css'
import s from '../ViewMessage.css';

const HostActions = (props) => {

	const dispatch = useDispatch();

	const loading = useSelector(state => state?.loader?.hostAction);

	const sendMessage = async (type) => {
		const { threadId, threadType, startDate, endDate, personCapacity, reservationId } = props;
		const { guestEmail, guestDisplayName, hostDisplayName, title, startTime, endTime } = props;

		if (type === 'preApproved') {
			dispatch(sendMessageAction(threadId, threadType, null, type, startDate, endDate, personCapacity, reservationId, null, null, null, null, startTime, endTime));
		} else {
			dispatch(sendMessageAction(threadId, threadType, null, type, startDate, endDate, personCapacity, reservationId, null, null, null, null, startTime, endTime));
		}
	}

	// Inquiry
	const inquiry = (guestDisplayName) => {
		const { createdAt } = props;
		let startDate, next24Hours, distance, options;
		startDate = moment();
		next24Hours = moment(Number(createdAt)).add(23, 'hours').add(59, 'minutes');
		distance = next24Hours - startDate;
		options = { endDate: next24Hours };
		if (distance < 0) {
			return expired(guestDisplayName);
		} else {
			return (
				<div className={cx(s.actionInnerBox, s.actionContainer, cs.spaceBottom5)}>
					<h4 className={cx(s.noMarginTop, cs.spaceBottom2, s.actionHeading)}>
						<FormattedMessage {...messages.hostAction1} /> {guestDisplayName} <FormattedMessage {...messages.hostAction2} />
					</h4>
					<p className={cx(s.actionPara, s.noMarginTop, cs.spaceBottom3)}><FormattedMessage {...messages.hostAction3} /> {guestDisplayName} <FormattedMessage {...messages.hostAction4} /></p>
					{
						distance > 0 && <p className={cx(s.actionPara, s.noMarginTop, cs.spaceBottom3)}>
							<ClockSvgIcon className={cx(s.timeIconColor, s.timerIcon, s.rsFromMessageMarginRight, 'rsFromMessageMarginRightRLT')} />
							<FormattedMessage {...messages.hostResponseTime1} /> <CountDown options={options} /> <FormattedMessage {...messages.hostResponseTime2} />
						</p>
					}
					{
						distance > 0 && <div className={cx()}>
							<Button className={s.btnPrimary} disabled={loading} onClick={() => sendMessage('preApproved')}>
								<FormattedMessage {...messages.preApprove} />
							</Button>
						</div>
					}

				</div>
			)
		};
	}

	// Request to book
	const requestToBook = (guestDisplayName) => {
		const { createdAt, listPublishStatus } = props;
		let startDate, next24Hours, distance, options;
		startDate = moment();
		next24Hours = moment(Number(createdAt)).add(23, 'hours').add(59, 'minutes');
		distance = next24Hours - startDate;
		options = { endDate: next24Hours };
		if (distance < 0) {
			return expired(guestDisplayName);
		} else {
			return (
				<div className={cx(s.actionInnerBox, s.actionContainer, cs.spaceBottom5)}>
					<h4 className={cx(s.noMarginTop, cs.spaceBottom2, s.actionHeading)}>{guestDisplayName} <FormattedMessage {...messages.guestRequest} /></h4>
					{
						distance > 0 && <p className={cx(s.actionPara, s.noMarginTop, cs.spaceBottom3)}>
							<FormattedMessage {...messages.hostResponseTime1} /> <CountDown options={options} /> <FormattedMessage {...messages.hostResponseTime2} />
						</p>
					}
					{
						listPublishStatus && distance > 0 && <div className={cx()}>
							<Button className={s.btnPrimary} disabled={loading} onClick={() => sendMessage('approved')}>
								<FormattedMessage {...messages.approve} />
							</Button>
							<Button className={cx(s.btnPrimaryBorder, s.btnRight, 'declineRTL')} disabled={loading} onClick={() => sendMessage('declined')}>
								<FormattedMessage {...messages.decline} />
							</Button>
						</div>
					}
				</div>
			)
		};
	}

	// Inquiry pre-approved
	const approved = () => {
		return (
			<div className={cx(s.actionInnerBox, s.actionContainer, cs.spaceBottom5)}>
				<h4 className={cx(s.noMarginTop, cs.spaceBottom2, s.actionHeading)}><FormattedMessage {...messages.requestApproved} /></h4>
				<p className={cx(s.actionPara, s.noMarginTop, s.marginBottom0)}>
					<FormattedMessage {...messages.timeToExpire} />
				</p>
			</div>
		);
	}

	// Request to book/ Inquiry declined
	const declined = () => {
		return (
			<div className={cx(s.actionInnerBox, s.actionContainer, cs.spaceBottom5)}>
				<h4 className={cx(s.noMarginTop, cs.spaceBottom2, s.actionHeading)}><FormattedMessage {...messages.requestDeclined} /></h4>
				<p className={cx(s.actionPara, s.noMarginTop, s.marginBottom0)}>
					<FormattedMessage {...messages.declinedInfo} />
				</p>
			</div>
		);
	}

	// Booking confirmed by host/ instant booking
	const bookingConfirmed = () => {
		const { reservationId } = props;
		return (
			<div className={cx(s.actionInnerBox, s.actionContainer, cs.spaceBottom5)}>
				<h4 className={cx(s.noMarginTop, cs.spaceBottom2, s.actionHeading)}><FormattedMessage {...messages.bookingIsConfirmed} /></h4>
				<p className={cx(s.actionPara, s.noMarginTop, cs.spaceBottom3)}>
					<FormattedMessage {...messages.contactGuest} />
				</p>
				<div className={cx()}>
					<Link to={"/cancel/" + reservationId + "/owner"} className={cx(s.linkBtn, s.btnPrimary, s.linkInline)}>
						<FormattedMessage {...messages.cancelReservation} />
					</Link>
				</div>
			</div>
		);
	}

	// Pre-approved or approved by host is expired
	const expired = (guestDisplayName) => {
		return (
			<div className={cx(s.actionInnerBox, s.actionContainer, cs.spaceBottom5)}>
				<h4 className={cx(s.noMarginTop, cs.spaceBottom2, s.actionHeading)}><FormattedMessage {...messages.bookingIsExpired} /></h4>
				<p className={cx(s.actionPara, s.noMarginTop, s.marginBottom0)}>
					{guestDisplayName}'s <FormattedMessage {...messages.bookingIsExpired1} />
				</p>
			</div>
		);
	}

	// Booking is cancelled by host
	const cancelled = (guestDisplayName) => {
		return (
			<div className={cx(s.actionInnerBox, s.actionContainer, cs.spaceBottom5)}>
				<h4 className={cx(s.noMarginTop, cs.spaceBottom2, s.actionHeading)}><FormattedMessage {...messages.bookingRequestCancel1} /></h4>
				<p className={cx(s.actionPara, s.noMarginTop, s.marginBottom0)}>
					{guestDisplayName}'s <FormattedMessage {...messages.bookingRequestCancel3} />
				</p>
			</div>
		);
	}

	const completed = () => {
		return (
			<div className={cx(s.actionInnerBox, s.actionContainer, cs.spaceBottom5)}>
				<h4 className={cx(s.noMarginTop, cs.spaceBottom2, s.actionHeading)}><FormattedMessage {...messages.reservationCompleted1} /></h4>
				<p className={cx(s.actionPara, s.noMarginTop, s.marginBottom0)}>
					<FormattedMessage {...messages.reservationCompleted2} />
				</p>
			</div>
		);
	}

	const { actionType, guestDisplayName } = props;
	if (actionType === 'inquiry') {
		return inquiry(guestDisplayName);
	} else if (actionType === 'preApproved') {
		return approved();
	} else if (actionType === 'declined') {
		return declined();
	} else if (actionType === 'intantBooking' || actionType === 'approved') {
		return bookingConfirmed();
	} else if (actionType === 'requestToBook') {
		return requestToBook(guestDisplayName);
	} else if (actionType === 'expired') {
		return expired(guestDisplayName);
	} else if (actionType === 'cancelledByHost' || actionType === 'cancelledByGuest') {
		return cancelled(guestDisplayName);
	} else if (actionType === 'completed') {
		return completed();
	} else return <div />;
}

HostActions.propTypes = {
	actionType: PropTypes.string.isRequired,
	sendMessageAction: PropTypes.any.isRequired,
	threadId: PropTypes.number.isRequired,
	reservationId: PropTypes.number,
	threadType: PropTypes.string.isRequired,
	startDate: PropTypes.string.isRequired,
	endDate: PropTypes.string.isRequired,
	personCapacity: PropTypes.number.isRequired,
	guestDisplayName: PropTypes.string.isRequired,
	createdAt: PropTypes.string.isRequired,
	formatMessage: PropTypes.any,
	hostDisplayName: PropTypes.string.isRequired,
};

export default withStyles(cs, s)(HostActions);